module.exports = __webpack_public_path__ + "static/media/option8.85c47394.png";